import { FC, PropsWithChildren, type JSX } from 'react';

import { Modal } from '@payaca/ambrosia';
import { HydratedPurchaseOrder } from '@payaca/types/materialsListTypes';
import ConfirmPurchaseOrderControl from '../confirmPurchaseOrderControl/ConfirmPurchaseOrderControl';
import './ConfirmPurchaseOrderModal.sass';

type Props = {
  purchaseOrder: HydratedPurchaseOrder;
  isOpen: boolean;
  onConfirmPurchaseOrderSuccess?: () => void;
  onClose?: () => void;
};
const ConfirmPurchaseOrderModal: FC<Props> = ({
  purchaseOrder,
  isOpen,
  onConfirmPurchaseOrderSuccess,
  onClose,
}: PropsWithChildren<Props>): JSX.Element => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Record purchases"
      className="confirm-purchase-order-modal"
    >
      <Modal.Body>
        <ConfirmPurchaseOrderControl
          purchaseOrder={purchaseOrder}
          onConfirmPurchaseOrderSuccess={onConfirmPurchaseOrderSuccess}
        />
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmPurchaseOrderModal;
